import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    blogAuthorCard: {
        display: 'flex',
        padding: spacing.medium,
    },
    name: Object.assign(Object.assign({}, theme.typography.small_bold), { marginRight: 12, [theme.breakpoints.up('sm')]: Object.assign({ display: 'inline' }, theme.typography.medium_bold) }),
    pipeSymbol: {
        marginRight: 12,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline',
        },
    },
    expertise: Object.assign(Object.assign({}, theme.typography.small_regular), { [theme.breakpoints.up('sm')]: Object.assign({ display: 'inline' }, theme.typography.medium_regular) }),
    bio: Object.assign(Object.assign({ marginTop: spacing.small }, theme.typography.small_regular), { position: 'relative', [theme.breakpoints.up('sm')]: {
            marginTop: 12,
        } }),
    image: {
        width: 80,
        height: 80,
        borderRadius: '50%',
        marginRight: spacing.small,
        [theme.breakpoints.up('sm')]: {
            width: 120,
            height: 120,
            marginRight: spacing.medium,
        },
    },
    socialLinksContainer: {
        marginTop: spacing.small,
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            marginTop: 12,
        },
    },
    authorSocialLink: {
        marginRight: spacing.medium,
        [theme.breakpoints.up('sm')]: {
            marginRight: spacing.large,
        },
    },
    readMoreButton: Object.assign(Object.assign({}, theme.typography.small_bold), { display: 'inline', textDecoration: 'underline', cursor: 'pointer' }),
    socialIcon: {
        width: 36,
        height: 36,
        [theme.breakpoints.up('sm')]: {
            width: 44,
            height: 44,
        },
    },
    titleContainer: {
        display: 'flex',
    },
    nameAndExpertiseContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));
export default useStyles;
